module.exports = __webpack_public_path__ + "static/media/quiz.ed43f36a.png";